import { render, staticRenderFns } from "./AMEmptinessPhonecase.vue?vue&type=template&id=8c7bac30&scoped=true"
import script from "./AMEmptinessPhonecase.vue?vue&type=script&lang=ts"
export * from "./AMEmptinessPhonecase.vue?vue&type=script&lang=ts"
import style0 from "./AMEmptinessPhonecase.vue?vue&type=style&index=0&id=8c7bac30&prod&lang=scss&scoped=true"
import style1 from "./AMEmptinessPhonecase.vue?vue&type=style&index=1&id=8c7bac30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7bac30",
  null
  
)

export default component.exports